import React, { Fragment, useState } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ConfirmationModal from '../../../../common/modal/ConfirmationModal';
import { deleteItineraryFoodSupplier } from '../../../../../actions/food/ItinerarySupplierFood';

const DeleteItinerarySupplierFoodButton = ({
  itinerarySupplierFoodId,
  dispatchDeleteItineraryFoodSupplier,
}) => {
  const [showModal, setShowModal] = useState(false);

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  const onClickDelete = () => {
    dispatchDeleteItineraryFoodSupplier(itinerarySupplierFoodId);
    closeModal();
  };

  return (
    <Fragment>
      <Button color="danger" onClick={openModal}>
        <i className="fa fa-trash-o" /> Eliminar
      </Button>

      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickDelete}
        onClickCancel={closeModal}
      />
    </Fragment>
  );
};

DeleteItinerarySupplierFoodButton.propTypes = {
  itinerarySupplierFoodId: PropTypes.number.isRequired,
  dispatchDeleteItineraryFoodSupplier: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchDeleteItineraryFoodSupplier: deleteItineraryFoodSupplier,
};

export default connect(
  null,
  mapDispatchToProps,
)(DeleteItinerarySupplierFoodButton);
